import { Injectable } from '@angular/core';
import { ITrackAdjustNativeService, ParamDefaultAdjust } from './itrack-adjust-native';

declare const trackStateToken;

declare global {
    interface Window {
        webkit: any;
    }
}

@Injectable({ providedIn: 'root' })
export class TrackAdjustNativeService implements ITrackAdjustNativeService {


    trackAdjust(paramDefautl: ParamDefaultAdjust) {
        const data = {
            ...paramDefautl,
        };

        /* Send mensage for IOS or Android */
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.trackStateToken) {
            this.trackAdjustIos(data);
        } else {
            this.trackAdjustAndroid(data);
        }
    }

    private trackAdjustIos(data: Record<string, string>) {
        window.webkit.messageHandlers.trackStateToken.postMessage({it_token: data.it_token});
    }
    
    private trackAdjustAndroid(data: Record<string, string>) {
        try {
            trackStateToken.postMessage(JSON.stringify(data));
        } catch (error) {
        }
    }
}

